import { useSheetStore } from "@/zustand/sheetStore";
import { useUser } from "@/zustand/store";
import { ChevronRight } from "lucide-react";

const ContactUs = () => {
  const { user } = useUser();
  const openTelegram = () => {
    window.open(
      "https://t.me/Cbrown_DigitWallet",
      "_blank",
      "noopener,noreferrer",
    );
  };
  const openEmail = () => {
    window.open("mailto:support@tetheruz.com", "_blank", "noopener,noreferrer");
  };
  return (
    <div>
      <h3 className="text-2xl text-[#BDE9FB]">Hello {user.firstName}, 👋🏻</h3>
      <h3 className="text-2xl">How can we help you?</h3>

      <div className="mt-4">
        <div className="rounded-lg bg-[#2C2D2FE5] px-3 py-3">
          <div
            onClick={openEmail}
            className="flex w-full items-center justify-between py-4 text-sm hover:cursor-pointer"
          >
            <div className="flex items-center gap-4">
              <img className="size-7" src="/icons/send-email.svg" alt="2fa" />
              <span>Send an Email</span>
            </div>
            <ChevronRight size={20} />
          </div>
          <div className="border-t border-[#283968]" />
          {/* <div
            onClick={openTelegram}
            className="flex w-full items-center justify-between py-4 text-sm hover:cursor-pointer"
          >
            <div className="flex items-center gap-4">
              <img
                className="size-7"
                src="/icons/send-telegram.svg"
                alt="2fa"
              />
              <span>Send an Telegram Message</span>
            </div>
            <ChevronRight size={20} />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
